export enum DealStatusEnum {
  Old = 50,
  Draft = 100,
  Requested = 200,
  Rejected = 300,
  Approved = 400,
  GracePeriod = 450,
  Deferred = 500,
  Late = 600,
  PendingDefault = 690,
  Defaulted = 700,
  Cancelled = 800,
  Completed = 1000,
  CanceledAndClosed = 1100,
  Closed = 1200,
  Refunded = 1300, // for commissions (external_deals)
}

export const DealStatusNames = {
  [DealStatusEnum.Old]: 'Old',
  [DealStatusEnum.Draft]: 'Draft',
  [DealStatusEnum.Requested]: 'Requested',
  [DealStatusEnum.Rejected]: 'Rejected',
  [DealStatusEnum.Approved]: 'Approved',
  [DealStatusEnum.GracePeriod]: 'Grace Period',
  [DealStatusEnum.Deferred]: 'Deferred',
  [DealStatusEnum.Late]: 'Late',
  [DealStatusEnum.PendingDefault]: 'Pending Default',
  [DealStatusEnum.Defaulted]: 'Defaulted',
  [DealStatusEnum.Cancelled]: 'Cancelled',
  [DealStatusEnum.Completed]: 'Completed',
  [DealStatusEnum.CanceledAndClosed]: 'Canceled & Closed',
  [DealStatusEnum.Closed]: 'Closed',
  [DealStatusEnum.Refunded]: 'Refunded',
};

export const dealStatusVerified = [
  DealStatusEnum.Approved,
  DealStatusEnum.Deferred,
  DealStatusEnum.Late,
  DealStatusEnum.PendingDefault,
  DealStatusEnum.Defaulted,
  DealStatusEnum.Completed,
  DealStatusEnum.CanceledAndClosed,
  DealStatusEnum.Closed,
];
export const dealStatusNotVerified = [
  DealStatusEnum.Draft,
  DealStatusEnum.Requested,
  DealStatusEnum.Rejected,
];

export enum DealStautsCommonEnum {
  Verified = 1,
  NotVerified = 2,
}

export const dealStautsCommonConverter = {
  [DealStautsCommonEnum.Verified]: dealStatusVerified,
  [DealStautsCommonEnum.NotVerified]: dealStatusNotVerified,
};

export const isSupportSchedulesPayments = [
  DealStatusEnum.Approved,
  DealStatusEnum.GracePeriod,
  DealStatusEnum.Deferred,
  DealStatusEnum.Late,
  DealStatusEnum.PendingDefault,
  DealStatusEnum.Defaulted,
  DealStatusEnum.Cancelled,
];
